import { render, staticRenderFns } from "./MultiTextQuestion.vue?vue&type=template&id=4bf1503a"
import script from "./MultiTextQuestion.vue?vue&type=script&lang=ts"
export * from "./MultiTextQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports